import React from "react";
import PopoverView from "src/components/PopoverView";
import FullScreen from "src/atoms/FullScreen";
import Flow from "src/components/Flow";
import steps from "./steps";

export default class PairingWizard extends React.Component {
  render() {
    const { initialStep, router, frame, closeWizard, app } = this.props;
    const renderAsModal = router.location.pathname !== "/welcome" && router.location.pathname !== "/onboarding";

    const flow = (
      <Flow
        key={initialStep}
        closeWizard={closeWizard}
        initialStep={initialStep}
        steps={steps}
        app={app}
        mode={renderAsModal ? "modal" : "fullScreen"}
        frame={frame}
      />
    );

    if (renderAsModal) {
      return (
        <PopoverView onClose={closeWizard} isOpen={renderAsModal && initialStep}>
          {flow}
        </PopoverView>
      );
    } else {
      if (initialStep === null) {
        return null;
      }
      return (
        <FullScreen position="fixed" zIndex={1}>
          {flow}
        </FullScreen>
      );
    }
  }
}
